import type { AccordionItem } from '@workspace/interfaces';
import { handleLinkClick } from '@workspace/hooks';
import { cn } from '@workspace/lib';

interface AccordionItemContentProps {
  item: AccordionItem;
  isExpanded: boolean;
  getHeight: (id: string) => number;
  contentRef: (el: HTMLDivElement | null) => void;
}

export function AccordionItemContent({ item, isExpanded, getHeight, contentRef }: AccordionItemContentProps) {
  return (
    <div
      id={`accordion-content-${item.id}`}
      className={cn(
        'overflow-y-hidden transition-all duration-500 ease-[cubic-bezier(0.22,1,0.36,1)] will-change-[height,opacity] motion-reduce:transition-none',
        isExpanded ? 'opacity-100' : 'opacity-0',
      )}
      style={{
        height: isExpanded ? getHeight(item.id) : 0,
      }}
    >
      <div className="pb-4 pt-5 space-y-[16px] md:space-y-2" ref={contentRef}>
        {item?.items?.map((link, index) => (
          <button
            key={link.id}
            onClick={(e) => handleLinkClick(link, e)}
            className={cn(
              'block w-full text-left text-gray-700 rounded-md cursor-pointer hover:text-primary transform-gpu transition-[opacity,transform,color] duration-400 ease-[cubic-bezier(0.22,1,0.36,1)] motion-reduce:transition-none',
              isExpanded ? 'translate-y-0 opacity-100' : 'translate-y-[-8px] opacity-0',
            )}
            style={{
              transitionDelay: isExpanded ? `${index * 50}ms` : '0ms',
            }}
          >
            <div className="flex items-center gap-3">
              <span className="flex-1 font-body text-base leading-6 underline decoration-solid hover:text-primary !min-w-max">
                {link.label}
              </span>
            </div>
          </button>
        ))}

        {(!item?.items || item.items.length === 0) && (
          <div className="text-center text-black py-4">
            <p>No documents available in this section</p>
          </div>
        )}
      </div>
    </div>
  );
}
